<template>
  <div class="l-container confirm-info">
    <!-- Breadcrumb -->
    <div class="top-title ml-2">
      <h3>獲得予定のベネポ</h3>
    </div>
    <div class="mt-6 mb-6 divider_title"></div>


    <!-- MAIN -->
    <div class="main-content flex">
      <!-- SIDEBAR -->
      <div class="left-content">
        <LeftMenuBar :navBars="navBars" />
      </div>
      <div class="right-content">
        <div class="detail-point">
          <i class="icon icon-bor-arrow-left text-red-500 flex items-center" />
          <a class="text-black" @click="gotoPath()">ベネポの確認に戻る</a>
        </div>
        <div class="list-content c-box">
          <div>
            <div class="title">
              <div>
                <h2>{{ title }}</h2>
              </div>
              <div class="title-point">
                <div v-show="is_hidden">
                  <p>{{ totalText }}</p>
                </div>
                <div>
                  <h1>{{ grantedPoint }}P</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="paging-list">
          <div class="base-content-bottom mx-8">
            <div class="item-pagination">
              <div class="w-1/4 sm:w-full flex items-center">
                <p class="total"><strong>{{ totalRecordPoint }}</strong>件中 
                <span v-if="page === 1 && totalRecordPoint"> 1 </span>
                <span v-if="!totalRecordPoint">0</span>
                <span v-if="page > 1"> {{ (page -1) * 10 + 1 }}</span>
                ～
                <span v-if="totalRecordPoint <= 10"> {{ totalRecordPoint }} </span>
                <span v-if="totalRecordPoint > 10 && ((page - 1) * 10 < Math.floor(totalRecordPoint/10)*10) "> {{ page * 10 }}</span>
                <span v-if="totalRecordPoint > 10 && ((page - 1) * 10 >= Math.floor(totalRecordPoint/10)*10 && (page - 1) * 10 < totalRecordPoint) "> {{ (page -1) * 10 + totalRecordPoint % 10}}</span>
                件表示
                </p>
              </div>
              <Pagination
                class="sm:w-full pt-2 pb-2 flex justify-center"
                @onChange="onChange"
                :totalRecord="totalRecordPoint"
                :page="page"
                :pageCount="5"
                :pageSlot="5"
              />
            </div>
          </div>

            <a-divider />
            <div>
              <div
                v-for="(item, index) in listPointHistory"
                :key="index"
                class="list-items"
              >
                <article>
                  <div class="item">
                    <div v-if="item && item.date">獲得予定日: {{ item.date }}</div>
                    <div v-if="item && !item.date">獲得予定日: 未定</div>
                    <!-- <div class="content pl-5"> {{ item.content }} </div> -->
                  </div>
                  <div class="lg-content">
                    <div class="two-lines-ellipsis f-14"> {{ item.content }} </div>
                  </div>
                  <div class="point">
                    <span class="font-bold">+{{ item.point | formatInteger }}P</span>
                  </div>
                </article>
                <div class="sm-content">
                    <div class="two-lines-ellipsis f-14 px-4"> {{ item.content }} </div>
                </div>
                <a-divider v-if="index < listPointHistory.length - 1" class="divider" />
              </div>
            </div>
            <a-empty v-if="listPointHistory.length === 0" />
              <div class="text-center" v-if="listPointHistory.length === 0"> 
                <span>{{ descriptionImageBlank }}</span>
              </div>
            <a-divider />
          </div>
          <div class="py-6 w-full text-center">
            <button class="c-btn bg-gray-200">
              <span class="px-16 font-bold sm:px-8">
                ベネポが使えるメニューを見る
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from '@/components/primitive'
import { LeftMenuBar } from '@/components/compound'
import { GET_POINT_HISTORY } from '@/store/modules/bs_myp/actions'
import _ from 'lodash'


export default {
  components: {
    Pagination,
    LeftMenuBar
  },
  data() {
    return {
      grantedPoint: null,
      is_hidden: true,
      windowWidth: null,
      totalRecordPoint: null,
      descriptionImageBlank: '誠に申し訳ございませんが、データがありませんでした',
      paramPointHistory: {
        commandType: 4,
        startIndex: 0,
        count: 10
      },
      listPointHistory: [],
      page: 1,
      title: '獲得予定ベネポ',
      totalText: '合計',
      totalPoint: '100P',
      breadcrumb_data: ['トップ', 'マイページ', 'ベネポの確認', '獲得予定のベネポ'],
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' }
      ]
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  mounted() {
    if (this.loggedIn) {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
      this.getTotalElePoint()
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  watch: {
    windowWidth() {
      if (this.windowWidth > 768) {
        this.is_hidden = true
      } else {
        this.is_hidden = false
      }
    }
  },
  methods: {
    formatDatePoint(timeStr) {
      const yearOfPointHist = timeStr.substr(0, 4)
      const monthOfPointHist = timeStr.substr(4, 2)
      const dayOfPointHist = timeStr.substr(6, 2)
      return `${yearOfPointHist}/${ monthOfPointHist}/${ dayOfPointHist}`  
    },
    getTotalElePoint() {
      const params = {
        commandType: 4
      }
      this.$store.dispatch(GET_POINT_HISTORY, params).then((data) => {
        if(data) {
          this.totalRecordPoint = _.get(data, 'historyDataList', '').length
          this.getListPointHistory(this.paramPointHistory)
        }
      })
    },
    getListPointHistory(params) {
      params.startIndex = this.page - 1
      if (params.startIndex === -1) {
        params.startIndex = 0
      }
      this.$store.dispatch(GET_POINT_HISTORY, params).then((data) => {
        if(data) {
          this.grantedPoint = _.get(data, 'grantedPoint', '')
        }
        this.listPointHistory = []
        if(data && data.historyDataList) {
          data.historyDataList.forEach(content => {
            const pointHistory = {}
            pointHistory.point = _.get(content, 'point', '')
            pointHistory.content = _.get(content, 'reasonCustomer', '')
            pointHistory.date = this.formatDatePoint(_.get(content, 'historyDate', ''))
            this.listPointHistory.push(pointHistory)
          })
        }
      })
    },
    onChange(page) {
      this.page = page
      this.paramPointHistory.startIndex = page
      this.getListPointHistory(this.paramPointHistory)
    },
    gotoPath() {
      const query = this.$route.query
      this.$router.push({path: '/mypage/benepo-history', query})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>